import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { setToLayer } from '@awaze/design-system.utils.react';
const LayerWrapper = styled.div `
  position: relative;
  ${({ layer }) => setToLayer(layer)}
`;
/**
 * The Portal component encapsulates the logic for rendering other React components in a React Portal. React Portals lift components out of their natural DOM placement and allow you to shift them to other parts of the DOM.
 *
 * This allows you to create components that can sit above the base page level (z-index: 0, ie, ground floor).
 *
 * Some examples include the `<Drawer>` component and using the `<Elevated>` component to wrap a `<Button variant="elevated">` or a `<SegmentedControl>`.
 *
 * To ensure the contents of a portal are higher or lower than other portal-ed elements, you can pass an optional `layer` prop which will force the `z-index` of the portal's root element to be either `-10` `0`, or `10` (the default if left blank is `0`).
 *
 * For detailed information on React Portals please [see the docs](https://reactjs.org/docs/portals.html).
 */
export const Portal = ({ children, rootElement, rootElementSelector = null, layer = 'midground', }) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    const portalRootElement = rootElementSelector
        ? document.querySelector(rootElementSelector)
        : rootElement || document.body;
    return ReactDOM.createPortal(_jsx(LayerWrapper, { layer: layer, children: children }), portalRootElement);
};
//# sourceMappingURL=portal.js.map